import React from "react";
import { ArrowRight, Shield } from "lucide-react";

const CTASection = ({ openPopup }) => {
  return (
    <section id="cta" className="cta-section">
      <div className="cta-overlay"></div>
      <div className="container">
        <div className="cta-content">
          <Shield className="cta-icon" size={64} />
          <h2 className="cta-title">Don't Wait - Protect Your Brand Today</h2>
          <p className="cta-description">
            Every day without trademark protection puts your brand at risk. Competitors could file similar marks, copycats could confuse your customers, and you could lose the rights to your own brand name. Take action now and secure your business's most valuable asset.
          </p>
          <div className="cta-benefits">
            <div className="cta-benefit">
              <ArrowRight className="benefit-arrow" size={20} />
              <span>Free consultation with trademark experts</span>
            </div>
            <div className="cta-benefit">
              <ArrowRight className="benefit-arrow" size={20} />
              <span>24-48 hour application processing</span>
            </div>
            <div className="cta-benefit">
              <ArrowRight className="benefit-arrow" size={20} />
              <span>98% success rate with expert guidance</span>
            </div>
          </div>
          <div className="cta-buttons">
            <button className="btn-primary-cta" onClick={openPopup}>
              Protect My Brand Now
            </button>
            <button className="btn-secondary-cta" onClick={openPopup}>
              Schedule Free Consultation
            </button>
          </div>
          <p className="cta-urgency">
            ⚡ Limited Time: Get 20% off our Enhanced and Deluxe packages this month
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
